/**
 * Laravelのバリデーションエラーレスポンス型
 */
export type LaravelValidationError = {
  response: {
    status: number;
    data: {
      message?: string;
      errors?: Record<string, string[]>;
    };
  };
};

/**
 * Laravelのバリデーションエラーかどうかを判定する型ガード
 */
export function isLaravelValidationError(error: unknown): error is LaravelValidationError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof (error as any).response === 'object' &&
    (error as any).response !== null &&
    'status' in (error as any).response &&
    'data' in (error as any).response
  );
}

export default LaravelValidationError;
